import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { LgvUserService } from '../../core/core.module';

@Component({
  selector: 'lgv-prelicense-banner',
  templateUrl: './prelicense-banner.component.html',
  styleUrls: ['./prelicense-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrelicenseBannerComponent implements OnInit {

  constructor(public lgvUserSvc: LgvUserService) { }

  ngOnInit(): void {
  }

}
